<template>
    <ais-instant-search ref="instantSearch" :search-client="searchClient" :index-name="getPostsIndex" @focus="showSearchResults">
        <ais-configure :hitsPerPage="10" />
        <div id="search">
            <ais-search-box ref="search">
                <div slot-scope="{ currentRefinement, isSearchStalled, refine }">
                    <input type="text"
                           placeholder="Search"
                           :value="currentRefinement"
                           @keyup="showSearchResults"
                           @input="refine($event.currentTarget.value)"
                           v-shortkey.focus="['/']"
                           ref="searchInput" />
                    <span :hidden="!isSearchStalled">Loading...</span>
                </div>
            </ais-search-box>
            <img src="/images/search-key-slash.svg" alt="/" class="shortcut-key">
        </div>
        <div id="search-results">
            <div class="container">
                <div>
                    <ais-stats></ais-stats>
                </div>
                <div class="grid justify-space-between">
                    <div class="col-md-7">
                        <ais-state-results ref="AISstate">
                            <p slot-scope="{ state: { query }, results: { hits } }" v-show="!hits.length">
                                No results found for the query: <q>{{ query }}</q>
                            </p>
                        </ais-state-results>
                        <ais-hits>
                            <div slot="item" slot-scope="{ item }">
                                <router-link
                                    @click.native="hideSearchResults"
                                    :to="{ name: 'view-post', params: { post: item.slug, group: item.group.slug } }"
                                    class="result result--person">
                                    <div class="result__image" v-if="item.featured_image !== null">
                                        <img :src="item.featured_image" v-if="item.featured_image !== null" />
                                    </div>
                                    <div class="result__content">
                                        <span class="result__url"><i class="icon ion-md-link"></i> /groups/{{ item.group.slug }}/{{ item.slug }}</span>
                                        <span class="result__title">{{ item.title }}</span>
                                        <span class="result__excerpt">{{ item.excerpt }}</span>
                                    </div>
                                </router-link>
                            </div>
                        </ais-hits>
                        <ais-pagination>
                            <div slot-scope="{
                                currentRefinement,
                                nbPages,
                                pages,
                                isFirstPage,
                                isLastPage,
                                refine,
                                createURL
                            }">
                                <ul class="pagination" v-if="nbPages">
                                    <li v-if="!isFirstPage">
                                        <a :href="createURL(0)" @click.prevent="refine(0)">
                                            ‹‹
                                        </a>
                                    </li>
                                    <li v-if="!isFirstPage">
                                        <a :href="createURL(currentRefinement - 1)" @click.prevent="refine(currentRefinement - 1)">
                                            ‹
                                        </a>
                                    </li>
                                    <li v-for="page in pages" :key="page">
                                        <a :href="createURL(page)" :style="{ fontWeight: page === currentRefinement ? 'bold' : '' }" @click.prevent="refine(page)">
                                            {{ page + 1 }}
                                        </a>
                                    </li>
                                    <li v-if="!isLastPage">
                                        <a :href="createURL(currentRefinement + 1)" @click.prevent="refine(currentRefinement + 1)">
                                            ›
                                        </a>
                                    </li>
                                    <li v-if="!isLastPage">
                                        <a :href="createURL(nbPages)" @click.prevent="refine(nbPages)">
                                            ››
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </ais-pagination>
                    </div>
                    <div class="col-md-4">
                        <ais-index :index-name="getTeamsIndex">
                            <ais-configure :hitsPerPage="4" />
                            <ais-state-results ref="AISstate">
                                <p slot-scope="{ state: { query }, results: { hits } }" v-show="!hits.length">
                                    No contacts found
                                </p>
                            </ais-state-results>
                            <ais-hits>
                                <template slot="item" slot-scope="{ item }">
                                    <router-link
                                        :to="getContactRoute(item)"
                                        class="card card--person"
                                        @click.native="hideSearchResults">
                                        <div class="header">
                                            <div class="avatar" v-if="item.avatar">
                                                <img :src="item.avatar"
                                                     width="30"
                                                     height="30"
                                                     class="circle border border-white"
                                                     v-if="typeof item.avatar !== 'undefined' && item.avatar !== null"/>
                                                <span class="initials circle border border-white" v-else>{{item.initials}}</span>
                                            </div>
                                            <h2 v-if="item.name">{{ item.name }}</h2>
                                            <h2 v-if="item.title">{{ item.title }}</h2>
                                        </div>
                                        <span class="job-title">{{item.job_title}}</span>
                                        <span class="meta" v-for="field in item.fields">
                                            <span class="meta__key" v-if="(field.label === 'Email' && team.hide_email === 1)?false:true">{{field.label}}:</span>
                                            <span class="meta__value" v-if="(field.label === 'Email' && team.hide_email === 1)?false:true">{{field.value}}</span>
                                        </span>
                                    </router-link>
                                </template>
                            </ais-hits>
                        </ais-index>
                    </div>
                </div>
            </div>
        </div>
    </ais-instant-search>
</template>

<script>
    import algoliasearch from 'algoliasearch/lite';

    export default {
        props: ['team'],
        data () {
            return {
                posts: null,
                people: null,
                searchClient: algoliasearch(
                    window.algolia_app_id,
                    window.algolia_key
                ),
            }
        },
        computed: {
            getPostsIndex: function(){
                return window.algolia_prefix + this.team.id + '_posts';
            },
            getTeamsIndex: function() {
                return  window.algolia_prefix + 'users';
            }

        },
        watch: {
            '$route' (to, from) {
                this.hideSearchResults();
            }
        },
        mounted() {
        },
        methods:{
            showSearchResults: function (ev){
                if(typeof this.$refs.AISstate.state.state.query !== "undefined" && this.$refs.AISstate.state.state.query.length > 0){
                    document.scrollingElement.classList.add('search-open');
                } else {
                    document.scrollingElement.classList.remove('search-open');
                }
            },
            hideSearchResults: function (ev){
                document.scrollingElement.classList.remove('search-open');
                if(typeof this.$refs.search !== "undefined"){
                    this.$refs.search.currentRefinement = "";
                }
            },
            getContactRoute: function (item){
                return (item.objectID.indexOf("Contact") !== -1)
                    ? { name: 'people-contact', params: { list: item.list_id, contact: item.id }}
                    : { name: 'view-profile', params: { user: item.id } };
            }
        }
    }
</script>

<style lang="scss">
    .ais-Stats{
        margin: 0 0 40px 0;
    }
</style>
